import Vue from 'vue'
import CONST from '@/utils/const'
import router from '@/router/index'
import Nzh from 'nzh'

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

export function sortChange(data, queryCondition) {
  const { prop, order } = data
  if (prop) {
    queryCondition.sort = prop
    queryCondition.order = order === 'ascending' ? 'asc' : 'desc'
  } else {
    queryCondition.sort = 'id'
    queryCondition.order = 'desc'
  }
}

export function df(value, cFormat) {
  let date = Date.now()
  if (value) {
    date = value
  }
  return parseTime(date, cFormat || '{y}-{m}-{d}')
}

export function dfOfNextDate(cFormat) {
  const date = new Date()
  date.setDate(date.getDate() + 1)
  return parseTime(date, cFormat || '{y}-{m}-{d}')
}

/**
 * 用于提供cascader组件的value转换map
 * e.g: dept_id = 5时 需要将值 5 转换 为按级次的 [1, 2, 5]
 * */
export function generateMapOfIdsArray(rows, mapOfIdsArray, mapOfNamesArray) {
  const handlerRows = (row, idsArray, namesArray) => {
    idsArray.push(row.id)
    namesArray.push(row.label)
    mapOfIdsArray[row.id] = idsArray
    if (mapOfNamesArray) {
      mapOfNamesArray[row.id] = namesArray
    }
    if (row.children && row.children.length > 0) {
      row.children.forEach(row => {
        handlerRows(row, Vue.prototype._.cloneDeep(idsArray), Vue.prototype._.cloneDeep(namesArray))
      })
    }
  }
  if (rows && rows.length > 0) {
    rows.forEach(row => {
      handlerRows(row, [], [])
    })
  }
}
export function generateMapOfIdAndIdsArray(rows, mapOfIdsArray, mapOfNamesArray, mapOfId) {
  const handlerRows = (row, idsArray, namesArray) => {
    idsArray.push(row.id)
    namesArray.push(row.label)
    mapOfId[row.id] = row
    mapOfIdsArray[row.id] = idsArray
    if (mapOfNamesArray) {
      mapOfNamesArray[row.id] = namesArray
    }
    if (row.children && row.children.length > 0) {
      row.children.forEach(row => {
        handlerRows(row, Vue.prototype._.cloneDeep(idsArray), Vue.prototype._.cloneDeep(namesArray))
      })
    }
  }
  if (rows && rows.length > 0) {
    rows.forEach(row => {
      handlerRows(row, [], [])
    })
  }
}
export function setTreeData(rows, callbackFun) {
  const handlerRows = (row) => {
    callbackFun(row)
    if (row.children && row.children.length > 0) {
      row.children.forEach(row => {
        handlerRows(row)
      })
    }
  }
  if (rows && rows.length > 0) {
    rows.forEach(row => {
      handlerRows(row)
    })
  }
}
/**
 * 清空对象的属性
 * */
export function resetValue(obj) {
  delete obj.id
  for (const attr in obj) {
    if (
      attr === 'token' ||
      attr === 'page' ||
      attr === 'rows' ||
      attr === 'total' ||
      attr === 'sort' ||
      attr === 'order' ||
      attr === 'type' ||
      attr === 'prev_type'
    ) {
      continue
    } else if (
      attr.endsWith('_amount') ||
      attr.endsWith('_count') ||
      attr === 'long' ||
      attr === 'wide' ||
      attr === 'high' ||
      attr === 'weight' ||
      attr === 'score'
    ) {
      obj[attr] = 0
    } else if (
      attr.endsWith('Map') ||
      attr.endsWith('Data') ||
      attr.endsWith('Array') ||
      attr.endsWith('List') ||
      attr.endsWith('Range') ||
      attr.endsWith('_details') ||
      attr === 'details' ||
      attr === 'files'
    ) {
      obj[attr] = []
    } else if (
      attr.startsWith('is_') ||
      attr.endsWith('_id') ||
      attr.endsWith('_id2') ||
      attr === 'status' ||
      attr.endsWith('_status')
    ) {
      obj[attr] = null
    } else {
      obj[attr] = ''
    }
  }
}
/**
 * 交换数组元素
 * */
export function swapElements(array, index1, index2) {
  array[index1] = array.splice(index2, 1, array[index1])[0]
  return array
}
/**
 * 公共的表格行变色
 * */
export function tableRowClassName({ row }) {
  if (row.status === CONST.SELL_ORDER_STATUS.find(status => status.name === '订单取消').id) {
    return 'cancel'
  }
  if (row.delivery_printed === CONST.PRINT_STATUS.find(status => status.name === '已打印').id) {
    return 'has-printed'
  }
  if (row.express_delivery_id !== 1) { // 1 是御茶配送
    return 'express'
  }
  if (row.status === CONST.SELL_ORDER_STATUS.find(status => status.name === '开始制作').id) {
    return 'start'
  }
  if (row.status === CONST.SELL_ORDER_STATUS.find(status => status.name === '制作完成').id) {
    return 'completed'
  }
  if (row.status === CONST.SELL_ORDER_STATUS.find(status => status.name === '质检完成').id) {
    return 'quality-control-completed'
  }
  if (row.status === CONST.SELL_ORDER_STATUS.find(status => status.name === '订单提货').id) {
    return 'warning'
  }
  if (row.status === CONST.SELL_ORDER_STATUS.find(status => status.name === '订单送出').id) {
    return 'warning'
  }
  if (row.status === CONST.SELL_ORDER_STATUS.find(status => status.name === '已经收款').id) {
    return 'success'
  }
  return ''
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num, digits) {
  return (+num || 0).toFixed(digits || CONST['DECIMAL'].DEFAULT_PRECISION)
    .toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function toThousandFilterNoZero(num, digits, suffix) {
  if (+num === 0) {
    return ''
  } else {
    if (suffix) {
      return toThousandFilter(num, digits) + ' ' + suffix
    } else {
      return toThousandFilter(num, digits)
    }
  }
}

/**
 * 将 阿拉伯数字 转换成 中文大写数字
 * @param num
 * @returns string
 */
export function convertNumToChinese(num) {
  const nzhcn = Nzh.cn
  return nzhcn.toMoney(num, { outSymbol: false })
}

export function localeCompare(array, compareField) {
  if (compareField) {
    return array.sort((obj1, obj2) => {
      return obj1[compareField].localeCompare(obj2[compareField], 'zh')
    })
  } else {
    return array.sort((obj1, obj2) => {
      return obj1.localeCompare(obj2, 'zh')
    })
  }
}

export function getConstColor(value, key) {
  const findItem = CONST[key].find(item => item.id === value)
  return findItem ? findItem.color : ''
}

export function getDelMsg(code) {
  return `确定删除 <label class="tip-msg">${code}</label> 吗？<br>
                    <label class="err-msg">请谨慎操作，不可恢复！</label>`
}

export function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)')
    .exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

export function goBack() {
  Vue.prototype.confirm('预订单可能尚未保存，确定离开吗？').then(_ => {
    router.push('/')
  }).catch(_ => {})
}

export function validMobile(val) {
  return /1\d{10}/.test(val)
}

export function validEmail(val) {
  return /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(val)
}



// WEBPACK FOOTER //
// ./src/utils/index.js